export default function TermsConditions() {
  return (
    <div data-testid="terms-conditions-page">
      <section className="container-px pt-16 md:pt-24 pb-16">
        <div className="max-w-3xl">
          <div className="overline mb-6">Legal</div>
          <h1 className="font-heading text-5xl md:text-6xl font-light tracking-tight text-ink leading-[1.05]">
            Terms & Conditions
          </h1>
          <p className="mt-6 text-lg text-ink-soft leading-relaxed">
            Last Updated: July 11, 2026. Please read these Terms & Conditions carefully before using the website (ospfudr.com) operated by Oswal Sabha Professional Forum.
          </p>
        </div>
      </section>

      <section className="container-px pb-24">
        <div className="max-w-3xl card-premium space-y-8">
          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">1. Agreement to Terms</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              By accessing or using our website, you agree to be bound by these Terms & Conditions. If you disagree with any part of these terms, you may not access or use the platform.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">2. Membership Application and Conduct</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              Applying for membership requires providing accurate, complete, and current information. The admin panel reserves the right to approve, moderate, reject, or suspend membership accounts at its discretion. Members must conduct themselves professionally and respectfully within the forum, directory, and during community activities.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">3. Professional Directory Usage</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              Our professional directory is designed for professional networking and community growth. You agree not to use directory information for scraping, spamming, sending unsolicited mass marketing, or harassment. Engaging in prohibited use may result in immediate termination of membership.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">4. Intellectual Property</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              The website and its original content, features, logos, and functionality are and will remain the exclusive property of Oswal Sabha Professional Forum and its licensors. You may not copy, modify, distribute, or reproduce any part of our site without prior written consent.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">5. Disclaimer and Limitation of Liability</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              The website is provided on an "AS IS" and "AS AVAILABLE" basis. We make no warranties, express or implied, regarding the accuracy, completeness, or reliability of any content, member profile, or services offered through the site. Under no circumstances shall we be liable for any direct, indirect, incidental, or consequential damages resulting from your use of the website.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">6. Changes to Terms</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              We reserve the right, at our sole discretion, to modify or replace these Terms & Conditions at any time. Any changes will be posted on this page with an updated revision date.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-medium text-ink mb-3">7. Governing Law</h2>
            <p className="text-ink-soft leading-relaxed text-sm">
              These Terms & Conditions shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
